import type { TimeseriesMetric, TimeseriesRange } from "@/api/dashboard";

export const METRIC_LABELS: Record<TimeseriesMetric, string> = {
  orders: "Bestellungen", revenue: "Umsatz", returns: "Retouren", units: "Lagerabgang",
};
// Lagerabgang = verkaufte Stückzahl (NICHT EK — supplier_price ~87% NULL, OI-048).
export const METRIC_SUBTITLES: Record<TimeseriesMetric, string> = {
  orders: "Anzahl Bestellungen je Bucket",
  revenue: "Bruttowarenwert (Σ Preis × Menge)",
  returns: "Stornierte Bestellungen",
  units: "Verkaufte Stückzahl",
};
export const RANGE_LABELS: Record<TimeseriesRange, string> = {
  "1M": "1 Monat", "2M": "2 Monate", "3M": "3 Monate", "6M": "6 Monate",
  "12M": "12 Monate", "24M": "24 Monate", "36M": "36 Monate",
};
export const UNIT_LABELS: Record<"day" | "week" | "month", string> = {
  day: "Tag", week: "Woche", month: "Monat",
};
export function formatMetricValue(metric: TimeseriesMetric, value: number): string {
  if (metric === "revenue") {
    return value.toLocaleString("de-DE", { style: "currency", currency: "EUR", maximumFractionDigits: 0 });
  }
  return value.toLocaleString("de-DE");
}
export function formatBucketLabel(iso: string, unit: "day" | "week" | "month"): string {
  const d = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(d.getTime())) return iso;
  if (unit === "month") return d.toLocaleDateString("de-DE", { month: "short", year: "2-digit" });
  return d.toLocaleDateString("de-DE", { day: "numeric", month: "short" });
}
